module.exports = __webpack_public_path__ + "assets/media/DEFAULT_PROFILE_IMAGE_ON_HOVER.184cf361.svg";